import type { PackagingReport, ReportTab } from "./week39-report-types";
import { displayPlanAllocations } from "./week39-day-plan-rows";

export const REPORT_TABS: Array<{ value: ReportTab; label: string; description: string }> = [
  { value: "overview", label: "Genel bakış", description: "Haftanın durumu ve önce bakılması gereken işler" },
  { value: "lines", label: "Hatlar", description: "Hangi hatta ne kadar iş kaldı?" },
  { value: "daily", label: "Günlük üretim", description: "Gün gün plan, üretim ve birikimli ilerleme" },
  { value: "orders", label: "İş emirleri", description: "Excel satırına kadar izlenebilir plan ve gerçekleşme" },
  { value: "products", label: "Ürünler", description: "Ürün bazında plan, üretim ve kalan miktar" },
  { value: "countries", label: "Ülkeler", description: "Ülke bazında paketleme planı; sevkiyat durumu değildir" },
  { value: "quality", label: "Veri kontrolleri", description: "Toplamları etkileyen veri eksikleri ve hesap uyarıları" },
  { value: "notes", label: "Gün notları", description: "Seçili işlere bağlı operasyon notları" },
];

export function reportStaffingEntries(report: PackagingReport): Array<{ date: string; lineName: string }> {
  return report.daily.flatMap((day) => [...new Set(report.rows.filter((row) => displayPlanAllocations(row.plan).some((allocation) => allocation.date === day.date))
    .map((row) => row.lineName))].map((lineName) => ({ date: day.date, lineName })));
}
